import {BaseApi} from "./baseService";
import {Headers, Http, RequestOptions, URLSearchParams} from "@angular/http";
import {ConfigService} from "./configService";
import 'rxjs/add/operator/toPromise';
import {Injectable} from "@angular/core";
import {BaseResponse} from "../objects/common/baseResponse";
import {User} from "../objects/users/user";
import {RegisterModel} from "../objects/users/registerModel";
import {ForgotPasswordModel} from "../objects/users/forgotPasswordModel";
import {ResetPasswordModel} from "../objects/users/resetPasswordModel";
import {App} from "../objects/apps/app";
import {UserInfoViewModel} from "../objects/auth/UserInfoViewModel";
import {UserSearchRequest} from "../objects/requests/userSearchRequest";
import {SearchResponse} from "../objects/responses/searchResponse";
import {Order} from "../objects/orders/order";

/**
 * Created by stas on 5/23/2017.
 */
@Injectable()
export class UserService extends BaseApi {

    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public login(username: string, password: string): Promise<any> {
        let url = `${this.config.ApiUrl}/Token`;
        let body = `username=${username}&password=${password}&grant_type=password`;
        let options = new RequestOptions({
            headers: new Headers({"Content-Type": "application/x-www-form-urlencoded"})
        });

        return this.http.post(url, body, options).toPromise();
    }

    public register(request: RegisterModel): Promise<BaseResponse<any>> {
        return this.post(new RequestOptions({
            url: 'users/register/',
            body: request
        }));
    }

    public forgotPassword(request: ForgotPasswordModel): Promise<any> {
        return this.post(new RequestOptions({
            url: 'users/forgotpassword/',
            body: request
        }));
    }

    public resetPassword(request: ResetPasswordModel): Promise<any> {
        return this.post(new RequestOptions({
            url: 'users/resetpassword/',
            body: request
        }));
    }

    public confirmEmail(code: string, userId: string): Promise<any> {
        let body = `code=${code}&userId=${userId}`;
        let options = new RequestOptions({
            headers: new Headers({"Content-Type": "application/x-www-form-urlencoded"})
        });

        return this.http.post(`${this.config.ApiUrl}/confirmemail`, body, options).toPromise();
    }

    public getUserInfo(userId: string): Promise<BaseResponse<User>> {
        return this.get(new RequestOptions({
            url: `users/${userId}/info`
        }));
    }

    public getUserApps(userId: string): Promise<BaseResponse<Array<App>>> {
        return this.get(new RequestOptions({
            url: `users/${userId}/apps`
        }));
    }

    public inviteUser(user: User): Promise<BaseResponse<User>> {
        return this.post(new RequestOptions({
            url: `users/invite`,
            body: user
        }));
    }

    /**
     * register user in the system when login via external
     * resources such as google
     * @param accessToken
     * @returns {null}
     */
    public externalRegister(accessToken: string): Promise<BaseResponse<User>> {
        let params = new RequestOptions({
            url: `api/Account/RegisterExternal`,
            headers: new Headers()
        });

        params.headers.append("Authorization", `Bearer ${accessToken}`);

        return this.post(params);
    }

    /**
     * get user info using accessToken that can be received
     * by externalLogin
     * @param accessToken
     * @returns {null}
     */
    public getExternalUserInfo(accessToken: string): Promise<BaseResponse<UserInfoViewModel>> {
        let params = new RequestOptions({
            url: `api/Account/UserInfo`,
            headers: new Headers()
        });

        if(accessToken)
            params.headers.append("Authorization", `Bearer ${accessToken}`);

        return this.get(params);
    }

    public getExternalLogin(provider: string){
        return this.get(new RequestOptions({
            url: `api/Account/ExternalLogin?provider=Google&response_type=token&client_id=self&redirect_uri=${this.configService.config.AdminUrl}/${this.configService.config.RedirectUrl}&state=kpxvpRAg4jMTv5QO9DBJjLO6ib4J6A-AO9sjx3H0k9s1`
        }));
    }

    public prepareExternalLogin() : Promise<BaseResponse<void>> {
        return this.get(new RequestOptions({
            url: `api/Account/PrepareExternalLogin`
        }));
    }

    public search(request: UserSearchRequest) : Promise<BaseResponse<SearchResponse<User>>> {

        let params = new URLSearchParams();

        params.append('query', String.isNullOrEmpty(request.Query) ? request.Query : encodeURIComponent(request.Query));
        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('fillOrders', request.FillOrders.toString());

        return this.get(new RequestOptions({
            url: `users/search`,
            search: params
        }));
    }

    public update(user: User): Promise<BaseResponse<User>> {
        return this.put(new RequestOptions({
            url: `users/update`,
            body: user
        }));
    }

    public create(user: User): Promise<BaseResponse<User>> {

        return this.post(new RequestOptions({
            url: `users/create`,
            body: user
        }));
    }

    public getById(id: number): Promise<BaseResponse<User>> {

        return this.get(new RequestOptions({
            url: `users/${id}`
        }));
    }

    public getAll(): Promise<BaseResponse<Array<User>>> {
        return this.get(new RequestOptions({
            url: 'users/all'
        }))
    }

    public getOrdersByAgentId(agentId: number, skip: number = 0, top: number = 10): Promise<BaseResponse<SearchResponse<Order>>> {
        let params = new URLSearchParams();

        params.append('top', top.toString());
        params.append('skip', skip.toString());

        return this.get(new RequestOptions({
            url: `users/${agentId}/orders`,
            search: params
        }));
    }

}


// WEBPACK FOOTER //
// ./app/services/userService.ts